module.exports = {"630223100":"威远镇","630223101":"丹麻镇","630223102":"高寨镇","630223103":"南门峡镇","630223104":"加定镇","630223105":"塘川镇","630223106":"五十镇","630223107":"五峰镇","630223200":"台子乡","630223201":"西山乡","630223202":"红崖子沟乡","630223203":"巴扎藏族乡","630223204":"哈拉直沟乡","630223205":"松多藏族乡","630223206":"东山乡","630223207":"东和乡","630223208":"东沟乡","630223209":"林川乡","630223210":"蔡家堡乡","630223400":"曹家堡临空综合经济园互助园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/630223.json
// module id = 3129
// module chunks = 0